import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import startOfDay from 'date-fns/startOfDay';

import FormGroup from '../../../../../../components/global/FormGroup';
import Alert from '../../../../../../components/global/Alert';
import { getFormikTouchedErrors } from '../../../../../../util/formik';
import Label from '../../../../../../components/global/Label';
import useBasename from '../../../../../../components/routing/useBasename';
import { BASENAME } from '../../../../../../constants/basenames';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    email_address: PropTypes.string,
  }),
  values: PropTypes.shape({
    name: PropTypes.string,
    date: PropTypes.string,
  }).isRequired,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
};

const WeddingEventDetails = ({
  user,
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
}) => {
  const basename = useBasename();
  const showProfileEmail = basename === BASENAME.SHUTTERBUG;
  const errorList = Object.values(getFormikTouchedErrors(errors, touched));
  const { date } = values;

  return (
    <Fragment>
      <FormGroup
        id="name"
        name="name"
        label="Gallery Name"
        labelType="expanded"
        placeholder="Enter gallery name here..."
        required
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.name}
      />
      <div className="row">
        <div className="col-12">
          {showProfileEmail && !user?.email_address && (
            <div className="row">
              <div className="col-12">
                <FormGroup
                  id="emailAddress"
                  name="email_address"
                  label="Your email"
                  labelType="expanded"
                  placeholder="name@example.com"
                  required
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email_address}
                />
              </div>
            </div>
          )}
          {!showProfileEmail && (
            <div className="row">
              <div className="col-12">
                <FormGroup
                  id="coupleEmailAddress"
                  name="couple_email_address"
                  label="Bride or groom’s email"
                  labelType="expanded"
                  placeholder="name@example.com"
                  required
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.couple_email_address}
                />
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-12">
              <FormGroup
                id="brideName"
                name="bride_name"
                label="Bride first name"
                labelType="expanded"
                placeholder="Eg: Brenda"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.bride_name}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <FormGroup
                id="groomName"
                name="groom_name"
                label="Groom first name"
                labelType="expanded"
                placeholder="Eg: John"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.groom_name}
              />
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <Label id="label-for-date" for="date" labelType="expanded">
              Wedding Date
            </Label>
            <div className="datepicker-gray-light">
              <DatePicker
                id="date"
                required
                onChange={selectedDate => {
                  handleChange({
                    target: {
                      name: 'date',
                      value: startOfDay(selectedDate),
                    },
                  });
                }}
                inline
                selected={date}
                className="form-control"
                isClearable
              />
            </div>
          </div>
        </div>
      </div>

      {errorList.length > 0 && (
        <Alert type="danger" className="mt-1 text-normal">
          <ul className="mb-0">
            {errorList.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}
    </Fragment>
  );
};

WeddingEventDetails.propTypes = propTypes;

export { WeddingEventDetails as EventShutterbugDetailsComp };

export default WeddingEventDetails;
